






















































import { Component } from "vue-property-decorator";
import Vue from "vue";
import { Func } from "mocha";
import { State, Action, Getter } from "vuex-class";
import router from "../router";

@Component({})
export default class TheMenu extends Vue {
  @State("ui") uiState: any;
  @State("socketState") socketState: any;
  @Action("initializeSignalR") initializeSignalR: any;

  timer: number = 0;
  get miniDrawer() {
    return this.uiState.miniMenu;
  }

  miniDrawerTriggered = true;
  routerOptions = router.options;
  items: any[] = [
    {
      icon: "build",
      text: () => {
        return "MAINTENANCE_TITLE";
      },
      children: [
        {
          icon: "widgets",
          name: "box",
          text: () => {
            return "ITEMS_TITLE";
          },
          click: (vue: Vue) => {
            vue.$router.push("/maintenance/products");
          }
        }, {
          icon: "archive",
          name: "archived-products",
          text: () => {
            return "ARCHIVED_PRODUCTS_TITLE";
          },
          click: (vue: Vue) => {
            vue.$router.push("/maintenance/archived-products");
          }
        }, {
          icon: "widgets",
          name: "import",
          text: () => {
            return "IMPORT_TITLE";
          },
          click: (vue: Vue) => {
            vue.$router.push("/maintenance/import");
          }
        }
      ]
    },
    {
      icon: "settings",
      text: () => {
        return "INVENTORY_TITLE";
      },
      children: [
        {
          icon: "group",
          name: "INVENTORY_TITLE",
          text: () => {
            return "INVENTORY_TITLE";
          },
          click: (vue: Vue) => {
            vue.$router.push("/inventory");
          }
        },
        {
          icon: "assessment",
          name: "INVENTORY_REPORT_TITLE",
          text: () => {
            return "INVENTORY_REPORT_TITLE";
          },
          click: (vue: Vue) => {
            vue.$router.push("/inventory/report");
          }
        }
     ]
    },
    {
      icon: "storage",
      text: () => {
        return "BASIC_DATA_TITLE";
      },
      children: [
        {
          icon: "location_city",
          name: "sites",
          text: () => {
            return "SITES_TITLE";
          },
          click: (vue: Vue) => {
            vue.$router.push("/maintenance/sites");
          }
        }, {
          icon: "devices",
          name: "deviceTypes",
          text: () => {
            return "DEVICE_TYPES_TITLE";
          },
          click: (vue: Vue) => {
            vue.$router.push("/maintenance/deviceTypes");
          }
        }, {
          icon: "account_balance",
          name: "costCenters",
          text: () => {
            return "COST_CENTERS_TITLE";
          },
          click: (vue: Vue) => {
            vue.$router.push("/maintenance/costCenters");
          }
        }, {
          icon: "category",
          name: "productStates",
          text: () => {
            return "PRODUCT_STATES_TITLE";
          },
          click: (vue: Vue) => {
            vue.$router.push("/maintenance/productStates");
          }
        }
      ]
    },
    {
      icon: "settings",
      text: () => {
        return "ADMINISTRATION_TITLE";
      },
      children: [
        {
          icon: "group",
          name: "users",
          text: () => {
            return "ADMIN_USERS_TITLE";
          },
          click: (vue: Vue) => {
            vue.$router.push("/settings/users");
          }
        },
        {
          icon: "history",
          name: "auditHistory",
          text: () => {
            return "AUDIT_HISTORY";
          },
          click: (vue: Vue) => {
            vue.$router.push("/audit-history");
          }
        }
     ]
    }
  ];

  /**
   * this wrapper is needed to pass down the vue instance to the click function in the menu items
   */
  menuAction(cb: (t) => void) {
    cb(this);
  }

  beforeCreate() {

    (this as any).$authorize
      .isAuthorized(["superadmin"])
      .then(() => {
        // --
      })
      .catch(() => {
        // -
      });

    (this as any).$authorize
      .isAuthorized(["administrator"])
      .then(() => {
        // --
      })
      .catch(() => {
        // -
      });

    (this as any).$authorize
      .isAuthorized(["office"])
      .then(() => {
        this.items = this.items.filter(menu => {
          return  menu.text() !== "ADMINISTRATION_TITLE";
        });
      })
      .catch(() => {
        // -
      });

    (this as any).$authorize
      .isAuthorized(["driver"])
      .then(() => {
        this.items = this.items.filter(menu => {
          return  menu.text() !== "ADMINISTRATION_TITLE";
        });
      })
      .catch(() => {
        // -
      });
  }

  created() {
    this.initializeSignalR();
  }

  getMenuByRoleAndPermissions(roleFilterFor): any[] {
    const that = this;

    const r = this.items.map( item => {
      const ch = item.children.filter( child => {
        // filter it based on the permission....
        return this.routerOptions.routes!.find(element => {
          if (element.name === child.name) {
            // is there permission define at route level?
            return !element.meta.permissions || element.meta.permissions.roles.includes(roleFilterFor);
          }
          return false;
        });
      });
      if (ch.length > 0) {
        item.children = ch;
        return item;
      }
      return null;
    });
    const r2 = r.filter(x => x != null);
    return r2;
  }

  beforeDestroy() {
    clearInterval(this.timer);
  }

  labelPrinterStatus() {
    if ( this.socketState.connected) {
      if (!this.miniDrawer) {
        return this.$t("LABEL_PRINTER_AVAILABLE");
      } else {
        return this.$t("LABEL_PRINTER_AVAILABLE_SMALL");
      }
    }

    if (!this.miniDrawer) {
        return this.$t("LABEL_PRINTER_UNAVAILABLE");
      } else {
        return this.$t("LABEL_PRINTER_UNAVAILABLE_SMALL");
    }
  }
}
